import * as React from "react";

function ShareIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={25} fill="none" {...props}>
      <path
        d="M18 22.85a2.893 2.893 0 01-2.125-.874A2.893 2.893 0 0115 19.85c0-.117.008-.238.025-.363s.042-.237.075-.337l-7.05-4.1c-.283.25-.6.445-.95.587-.35.142-.717.213-1.1.213a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 013 12.85c0-.834.292-1.542.875-2.125A2.893 2.893 0 016 9.85c.383 0 .75.07 1.1.212.35.142.667.338.95.588l7.05-4.1a1.843 1.843 0 01-.075-.337A2.75 2.75 0 0115 5.85c0-.834.292-1.542.875-2.125A2.893 2.893 0 0118 2.85c.833 0 1.542.291 2.125.875.583.583.875 1.291.875 2.125 0 .833-.292 1.541-.875 2.125A2.893 2.893 0 0118 8.85c-.383 0-.75-.071-1.1-.213a3.284 3.284 0 01-.95-.587l-7.05 4.1c.033.1.058.212.075.337a2.753 2.753 0 010 .725 1.838 1.838 0 01-.075.338l7.05 4.1c.283-.25.6-.446.95-.588.35-.142.717-.212 1.1-.212.833 0 1.542.291 2.125.875.583.583.875 1.291.875 2.125 0 .833-.292 1.541-.875 2.125A2.893 2.893 0 0118 22.85z"
        fill="#2F3A49"
      />
    </svg>
  );
}

const MemoShareIcon = React.memo(ShareIcon);
export default MemoShareIcon;
